import {
  SELLER_ID,
  STORE_ID,
  BANK_CODE,
  SORT,
} from './fields';

export default function payload() {
  return {
    seller_ids: [{
      field: SELLER_ID,
    }],
    store_ids: [{
      field: STORE_ID,
    }],
    approved_bank_codes: [{
      field: BANK_CODE,
    }],
    sort: {
      field: SORT,
    },
  };
}
